import { doc, getDoc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import type { MoveProfile, MoveProfileDraft } from '@easymoving/types';
import { firebaseDb } from '../firebase/init';
import { toMillis } from './serialize';

/** Singleton move-profile doc per user (users/{uid}/meta/moveProfile). */
function ref(uid: string) {
  return doc(firebaseDb(), 'users', uid, 'meta', 'moveProfile');
}

export function fromDoc(d: Record<string, unknown>): MoveProfile {
  return {
    moveDate: typeof d.moveDate === 'number' ? d.moveDate : undefined,
    newAddress: typeof d.newAddress === 'string' ? d.newAddress : undefined,
    currentHomeSize: d.currentHomeSize as MoveProfile['currentHomeSize'],
    destinationHomeSize: d.destinationHomeSize as MoveProfile['destinationHomeSize'],
    moveType: d.moveType as MoveProfile['moveType'],
    originScope: d.originScope as MoveProfile['originScope'],
    destinationScope: d.destinationScope as MoveProfile['destinationScope'],
    sourceRoom: typeof d.sourceRoom === 'string' ? d.sourceRoom : undefined,
    updatedAt: toMillis(d.updatedAt),
  };
}

export async function getMoveProfile(uid: string): Promise<MoveProfile | null> {
  const snap = await getDoc(ref(uid));
  return snap.exists() ? fromDoc(snap.data()) : null;
}

export function subscribeMoveProfile(
  uid: string,
  cb: (p: MoveProfile | null) => void,
): () => void {
  return onSnapshot(ref(uid), (snap) => cb(snap.exists() ? fromDoc(snap.data()) : null));
}

export async function saveMoveProfile(uid: string, patch: MoveProfileDraft): Promise<void> {
  await setDoc(ref(uid), { ...patch, updatedAt: serverTimestamp() }, { merge: true });
}
